let searchInputs = [
    {
        id: 'reseller',
        label: 'Reseller',
        type: 'select',
        options: [
           
        ]
    },
    {
        id: 'emailAddress',
        label: 'Email Address',
        type: 'text',
        placeholder: 'Email Address'
    }
]
export { searchInputs }